import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-del",
  "use": "icon-del-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-del\"><defs><style>#icon-del .a,#icon-del .b{fill:none;}#icon-del .b{stroke:#333;stroke-width:1.5px;}</style></defs><rect class=\"a\" width=\"30\" height=\"30\" /><g transform=\"translate(5 6)\"><path class=\"b\" d=\"M-3778.129,13870.4v12.649h13V13870.4\" transform=\"translate(3781.628 -13865.662)\" /><path class=\"b\" d=\"M-3773.6,13870.785v8.529\" transform=\"translate(3780.999 -13866.05)\" /><path class=\"b\" d=\"M-3773.6,13870.785v8.529\" transform=\"translate(3785.999 -13866.05)\" /><path class=\"b\" d=\"M0,0V20\" transform=\"translate(0 3) rotate(-90)\" /><path class=\"b\" d=\"M0,0V10\" transform=\"translate(5.001) rotate(-90)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/del.svg
// module id = bpt5
// module chunks = 62